// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yovo-calendar-shimmer {
  display: flex;
  gap: 24px;
  min-height: 320px;
  padding: 8px 4px 12px;
  box-sizing: border-box;
}

.yovo-calendar-shimmer__month {
  flex: 1 1 260px;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.yovo-calendar-shimmer__title,
.yovo-calendar-shimmer__weekday,
.yovo-calendar-shimmer__date {
  border-radius: 6px;
  background: linear-gradient(90deg, #f3f3f7 25%, #e8e8ee 37%, #f3f3f7 63%);
  background-size: 400% 100%;
  animation: yovo-calendar-shimmer 1.2s ease-in-out infinite;
}

.yovo-calendar-shimmer__title {
  width: 46%;
  height: 18px;
  margin: 4px auto 8px;
  border-radius: 8px;
}

.yovo-calendar-shimmer__weekdays,
.yovo-calendar-shimmer__dates {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
}

.yovo-calendar-shimmer__weekday {
  height: 12px;
  border-radius: 4px;
}

.yovo-calendar-shimmer__date {
  height: 28px;
  border-radius: 8px;
}

@keyframes yovo-calendar-shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: 0 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/datePicker/CalendarShimmer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;EAGE,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".yovo-calendar-shimmer {\n  display: flex;\n  gap: 24px;\n  min-height: 320px;\n  padding: 8px 4px 12px;\n  box-sizing: border-box;\n}\n\n.yovo-calendar-shimmer__month {\n  flex: 1 1 260px;\n  min-width: 260px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.yovo-calendar-shimmer__title,\n.yovo-calendar-shimmer__weekday,\n.yovo-calendar-shimmer__date {\n  border-radius: 6px;\n  background: linear-gradient(90deg, #f3f3f7 25%, #e8e8ee 37%, #f3f3f7 63%);\n  background-size: 400% 100%;\n  animation: yovo-calendar-shimmer 1.2s ease-in-out infinite;\n}\n\n.yovo-calendar-shimmer__title {\n  width: 46%;\n  height: 18px;\n  margin: 4px auto 8px;\n  border-radius: 8px;\n}\n\n.yovo-calendar-shimmer__weekdays,\n.yovo-calendar-shimmer__dates {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.yovo-calendar-shimmer__weekday {\n  height: 12px;\n  border-radius: 4px;\n}\n\n.yovo-calendar-shimmer__date {\n  height: 28px;\n  border-radius: 8px;\n}\n\n@keyframes yovo-calendar-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
